import { useEffect, useState, type ReactElement } from "react";
import { Layout } from "./components/Layout";
import { Sidebar } from "./components/Sidebar";
import { Dashboard } from "./pages/Dashboard";
import { Tasks } from "./pages/Tasks";
import { Branches } from "./pages/Branches";
import { Clients } from "./pages/Clients";
import { Signals } from "./pages/Signals";
import { Chat } from "./pages/Chat";
import { Ide } from "./pages/Ide";
import { Rollouts } from "./pages/Rollouts";
import { SettingsPage } from "./pages/Settings";
import { Jarvis } from "./pages/Jarvis";
import { Pipeline } from "./pages/Pipeline";
import { setToken } from "./api/client";
import { wsClient } from "./api/ws";

export type PageId =
  | "dashboard"
  | "tasks"
  | "pipeline"
  | "jarvis"
  | "branches"
  | "clients"
  | "signals"
  | "chat"
  | "ide"
  | "rollouts"
  | "settings";

const PAGES: Record<PageId, () => ReactElement> = {
  dashboard: Dashboard,
  tasks: Tasks,
  pipeline: Pipeline,
  jarvis: Jarvis,
  branches: Branches,
  clients: Clients,
  signals: Signals,
  chat: Chat,
  ide: Ide,
  rollouts: Rollouts,
  settings: SettingsPage,
};

function TokenGate({ onReady }: { onReady: () => void }) {
  const [val, setVal] = useState("");
  return (
    <div className="flex h-screen items-center justify-center">
      <form
        className="card w-full max-w-sm space-y-3"
        onSubmit={(e) => {
          e.preventDefault();
          setToken(val.trim());
          onReady();
        }}
      >
        <h1 className="text-lg font-semibold">Coagent Console</h1>
        <p className="text-sm text-panel-muted">
          Вставь ADMIN_TOKEN (задан в .env сервера) чтобы войти.
        </p>
        <input
          className="w-full rounded border border-panel-border bg-panel-bg px-3 py-2 text-sm"
          type="password"
          value={val}
          onChange={(e) => setVal(e.target.value)}
          placeholder="ADMIN_TOKEN"
          autoFocus
        />
        <button className="btn btn-primary w-full">Войти</button>
      </form>
    </div>
  );
}

export default function App() {
  const [page, setPage] = useState<PageId>("dashboard");
  const [authed, setAuthed] = useState<boolean>(
    typeof localStorage !== "undefined" && Boolean(localStorage.getItem("coagent_console_token")),
  );

  useEffect(() => {
    if (authed) wsClient.connect();
  }, [authed]);

  if (!authed) return <TokenGate onReady={() => setAuthed(true)} />;

  const PageComponent = PAGES[page];
  return (
    <Layout
      sidebar={<Sidebar active={page} onNavigate={setPage} />}
      main={<PageComponent />}
    />
  );
}
